import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, Tag } from "./kit";
import { api } from "../lib/api";

const label = (x, lg) => x.label?.[lg] || x.label?.en || x.key;

// Read-only "How this is assessed": rubric criteria and critical errors from the unit (no grading logic here).
export function AssessmentInfo({ rubric, vid, unitKey }) {
  const { t, i18n } = useTranslation();
  const lg = (i18n.language || "en").startsWith("ru") ? "ru" : "en";
  const [r, setR] = useState(rubric || null);
  useEffect(() => { if (!rubric && vid && unitKey) api.get(`/learning/units/${vid}/${unitKey}`).then((x) => setR(x.data.unit?.rubric || null)).catch(() => setR(null)); }, [rubric, vid, unitKey]);
  const crit = r?.criteria || [], errs = r?.critical_errors || [];
  if (!crit.length && !errs.length) return null;
  return (
    <Card className="space-y-3" data-testid="assessment-info">
      <h2 className="font-bold">{t("ai.title")}</h2>
      <p className="text-sm text-muted-foreground">{t("ai.note")}</p>
      {crit.length > 0 && <div><h3 className="text-sm font-semibold">{t("ai.criteria")}</h3>
        <ul className="mt-1 space-y-1 text-sm">{crit.map((c) => <li key={c.key} data-testid={`ai-criterion-${c.key}`} className="flex flex-wrap items-center gap-2">{label(c, lg)}{c.mandatory && <Tag>{t("ai.mandatory")}</Tag>}</li>)}</ul></div>}
      {errs.length > 0 && <div><h3 className="text-sm font-semibold">{t("ai.critical")}</h3>
        <ul className="mt-1 list-disc space-y-1 pl-5 text-sm">{errs.map((e) => <li key={e.key} data-testid={`ai-critical-${e.key}`}>{label(e, lg)}</li>)}</ul></div>}
    </Card>
  );
}
